document.querySelector('.faq__search input').addEventListener('input', event => {
  const searchTerm = event.target.value.toLowerCase();
  const contentHalves = document.querySelectorAll('.faq__content-half');
  contentHalves.forEach(contentHalf => {
    const accordions = contentHalf.querySelectorAll('.accordion');
    let contentHalfHasMatch = false;
    accordions.forEach(accordion => {
      const listItems = accordion.querySelectorAll('.text-with-icon, .prose');
      let accordionHasMatch = false;
      let questionMatch = false;
      let answerMatch = false;
      listItems.forEach(item => {
        const itemText = item.textContent.toLowerCase();
        if (itemText.includes(searchTerm)) {
          item.style.display = 'block';
          if (item.classList.contains('text-with-icon')) {
            questionMatch = true;
          }
          if (item.classList.contains('prose')) {
            answerMatch = true;
          }
        } else {
          item.style.display = 'none';
        }
      });
      if (questionMatch || answerMatch) {
        accordion.style.display = 'block';
        accordion.querySelector('.text-with-icon').style.display = 'block';
        accordion.querySelector('.prose').style.display = 'block';
        contentHalfHasMatch = true;
      } else {
        accordion.style.display = 'none';
        accordion.querySelector('.text-with-icon').style.display = 'none';
        accordion.querySelector('.prose').style.display = 'none';
      }
    });
    if (contentHalfHasMatch) {
      contentHalf.style.display = 'block';
    } else {
      contentHalf.style.display = 'none';
    }
  });
  const allContentHalvesHidden = Array.from(contentHalves).every(contentHalf => contentHalf.style.display === 'none');
  const faqContent = document.querySelector('.faq__content');
  if (allContentHalvesHidden) {
    faqContent.style.display = 'none';
  } else {
    faqContent.style.display = 'flex';
  }
});